var KModalSize;
(function (KModalSize) {
    KModalSize["XSmall"] = "XSMALL";
    KModalSize["Small"] = "SMALL";
    KModalSize["Regular"] = "REGULAR";
    KModalSize["Large"] = "LARGE";
    KModalSize["Full"] = "FULL";
})(KModalSize || (KModalSize = {}));

export { KModalSize };
//# sourceMappingURL=types.js.map
